import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function sonSemanasDiferentes(fecha1: Date, fecha2: Date): boolean {
  const obtenerLunes = (fecha: Date) => {
    const d = new Date(fecha);
    if (d.toString() === 'Invalid Date')
        return null;

    d.setHours(0, 0, 0, 0);

    const dia = d.getDay(); // Domingo = 0, lunes = 1...
    d.setDate(d.getDate() - (dia === 0 ? 6 : dia - 1));

    return d.getTime();
  };

  const lunesFecha1 = obtenerLunes(fecha1); 
  const lunesFecha2 = obtenerLunes(fecha2);

  if (lunesFecha1 === null || lunesFecha2 === null)
      return false;  // En caso de error, devolver falso positivo (ambos días en misma semana)

  return lunesFecha1 !== lunesFecha2;
}
